module.exports = __webpack_public_path__ + "img/item_other@2x.43e31a48.png";